import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ForAdvisors from './pages/ForAdvisors';
import Partners from './pages/Partners';
import Pricing from './pages/Pricing';
import Apply from './pages/Apply';

/**
 * advisor-web 路由（顾问申请站）
 *
 * - /          → ForAdvisors landing
 * - /partners  → 合作伙伴计划
 * - /pricing   → 3 档定价 + FAQ
 * - /apply     → 申请加入（真实落库）
 * - /login     → 跳转大后台登录（admin.coverfy.ai/login）
 */
export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<ForAdvisors />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
